import { DEFAULT_CONFIGS } from "./defaults.js";
import { AUDIO_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginAudio = (config) => {
  return {
    config: { ...DEFAULT_CONFIGS.viewer, ...config },
    type: AUDIO_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginAudio
};
//# sourceMappingURL=viewer.js.map
